import React, { useEffect, useState } from "react";
import lz from "lzutf8";
import { useEditor } from "@craftjs/core";
import { ICustomComponent } from "@types";

export interface IViewportSize {
  type: "desktop" | "laptop" | "tablet" | "mobile";
  width: number;
  height: number;
}
export interface IBuilderContext {
  onSave?: (json: string) => void;
  onPreview?: (json: string) => void;
  pageContent?: string;
  viewport?: IViewportSize;
  setViewport?: (size: IViewportSize) => void;
  customComponents?: ICustomComponent[];
}

export const BuilderContext = React.createContext<IBuilderContext>({});

export const BuilderContextProvider: React.FC<
  React.PropsWithChildren<IBuilderContext>
> = ({ onSave, onPreview, pageContent, customComponents, children }) => {
  const { actions } = useEditor();
  const [viewport, setViewport] = useState<IViewportSize>({
    type: "desktop",
    width: 1200,
    height: 696,
  });

  useEffect(() => {
    if (pageContent) {
      const json = lz.decompress(lz.decodeBase64(pageContent));
      actions.deserialize(json);
    }
  }, []);

  const onSaveFunc = (json: string) => {
    onSave?.(json);
  };

  const onPewviewFunc = (json: string) => {
    onPreview?.(json);
  };

  {
    return (
      <BuilderContext.Provider
        value={{
          onSave: onSaveFunc,
          onPreview: onPewviewFunc,
          viewport: viewport,
          setViewport: setViewport,
          customComponents: customComponents,
        }}
      >
        {children}
      </BuilderContext.Provider>
    );
  }
};
